// Mock data for Folalabi Farms website

export const products = [
  {
    id: 'yams',
    name: 'Yam',
    slug: 'yam',
    description: 'Quality Nigerian yams sourced for wholesale and export supply.',
    image: 'https://images.unsplash.com/photo-1757283961582-ab596b0ca595?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxmcmVzaCUyMHlhbXN8ZW58MHx8fHwxNzcxMjgwMTE4fDA&ixlib=rb-4.1.0&q=85',
    category: 'Root Vegetables',
    details: {
      packaging: 'Cartons, pallets, or container shipments depending on buyer requirements',
      origin: 'Nigeria',
      notes: 'Available for wholesale enquiries and export coordination'
    }
  },
  {
    id: 'garri',
    name: 'Garri (White & Yellow)',
    slug: 'garri',
    description: 'Nigerian garri in both white and yellow varieties, sourced for wholesale distribution.',
    image: 'https://images.unsplash.com/photo-1655912108021-5a81aa63cc3d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxjYXNzYXZhJTIwbGVhdmVzfGVufDB8fHx8MTc3MTI4MDEyMnww&ixlib=rb-4.1.0&q=85',
    category: 'Processed Foods',
    details: {
      packaging: 'Various packaging sizes available including cartons and bulk shipments',
      origin: 'Nigeria',
      notes: 'Contact for pricing and availability discussions'
    }
  },
  {
    id: 'palm-oil',
    name: 'Palm Oil',
    slug: 'palm-oil',
    description: 'Nigerian palm oil sourced for wholesale and export supply.',
    image: 'https://customer-assets.emergentagent.com/job_african-agro-export/artifacts/z3iwcgvt_palm%20oil.jpg',
    category: 'Oils',
    details: {
      packaging: 'Jerry cans, drums, or bulk containers depending on order volume',
      origin: 'Nigeria',
      notes: 'Available for wholesale and export enquiries'
    }
  },
  {
    id: 'beans',
    name: 'Beans',
    slug: 'beans',
    description: 'Nigerian beans sourced for wholesale distribution and export.',
    image: 'https://images.unsplash.com/photo-1757283961544-e161ac41b201?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwyfHxmcmVzaCUyMHlhbXN8ZW58MHx8fHwxNzcxMjgwMTE4fDA&ixlib=rb-4.1.0&q=85',
    category: 'Grains & Legumes',
    details: {
      packaging: 'Bags, cartons, or palletized shipments',
      origin: 'Nigeria',
      notes: 'Contact for sourcing and availability'
    }
  },
  {
    id: 'egusi',
    name: 'Egusi',
    slug: 'egusi',
    description: 'Nigerian egusi (melon seeds) for wholesale and export supply.',
    image: 'https://images.unsplash.com/photo-1757283961582-ab596b0ca595?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxmcmVzaCUyMHlhbXN8ZW58MHx8fHwxNzcxMjgwMTE4fDA&ixlib=rb-4.1.0&q=85',
    category: 'Seeds & Spices',
    details: {
      packaging: 'Various packaging formats available',
      origin: 'Nigeria',
      notes: 'Wholesale enquiries welcome'
    }
  },
  {
    id: 'fufu',
    name: 'Fufu',
    slug: 'fufu',
    description: 'Nigerian fufu flour sourced for wholesale distribution.',
    image: 'https://images.unsplash.com/photo-1655912108021-5a81aa63cc3d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxjYXNzYXZhJTIwbGVhdmVzfGVufDB8fHx8MTc3MTI4MDEyMnww&ixlib=rb-4.1.0&q=85',
    category: 'Processed Foods',
    details: {
      packaging: 'Cartons and bulk shipment options',
      origin: 'Nigeria',
      notes: 'Available for export coordination'
    }
  },
  {
    id: 'ofada-rice',
    name: 'Ofada Rice',
    slug: 'ofada-rice',
    description: 'Nigerian ofada rice sourced for wholesale and export.',
    image: 'https://images.unsplash.com/photo-1757283961544-e161ac41b201?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwyfHxmcmVzaCUyMHlhbXN8ZW58MHx8fHwxNzcxMjgwMTE4fDA&ixlib=rb-4.1.0&q=85',
    category: 'Grains & Legumes',
    details: {
      packaging: 'Bags or palletized formats',
      origin: 'Nigeria',
      notes: 'Contact for availability and pricing'
    }
  },
  {
    id: 'plantain-flour',
    name: 'Plantain Flour',
    slug: 'plantain-flour',
    description: 'Nigerian plantain flour for wholesale distribution.',
    image: 'https://images.unsplash.com/photo-1655912108021-5a81aa63cc3d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxjYXNzYXZhJTIwbGVhdmVzfGVufDB8fHx8MTc3MTI4MDEyMnww&ixlib=rb-4.1.0&q=85',
    category: 'Processed Foods',
    details: {
      packaging: 'Various sizes available',
      origin: 'Nigeria',
      notes: 'Wholesale and export enquiries supported'
    }
  },
  {
    id: 'ugu-leaves',
    name: 'Ugu Leaves',
    slug: 'ugu-leaves',
    description: 'Nigerian ugu leaves sourced for wholesale supply.',
    image: 'https://images.unsplash.com/photo-1655912108021-5a81aa63cc3d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxjYXNzYXZhJTIwbGVhdmVzfGVufDB8fHx8MTc3MTI4MDEyMnww&ixlib=rb-4.1.0&q=85',
    category: 'Leafy Vegetables',
    details: {
      packaging: 'Appropriate packaging for freshness',
      origin: 'Nigeria',
      notes: 'Subject to availability - contact for enquiries'
    }
  },
  {
    id: 'chin-chin',
    name: 'Chin-Chin',
    slug: 'chin-chin',
    description: 'Nigerian chin-chin snacks for wholesale distribution.',
    image: 'https://images.unsplash.com/photo-1757283961582-ab596b0ca595?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxmcmVzaCUyMHlhbXN8ZW58MHx8fHwxNzcxMjgwMTE4fDA&ixlib=rb-4.1.0&q=85',
    category: 'Snacks',
    details: {
      packaging: 'Cartons for retail or wholesale',
      origin: 'Nigeria',
      notes: 'Available for bulk orders'
    }
  },
  {
    id: 'kulikuli',
    name: 'Kulikuli',
    slug: 'kulikuli',
    description: 'Nigerian kulikuli (groundnut cakes) for wholesale supply.',
    image: 'https://images.unsplash.com/photo-1757283961582-ab596b0ca595?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxmcmVzaCUyMHlhbXN8ZW58MHx8fHwxNzcxMjgwMTE4fDA&ixlib=rb-4.1.0&q=85',
    category: 'Snacks',
    details: {
      packaging: 'Bulk packaging available',
      origin: 'Nigeria',
      notes: 'Contact for wholesale enquiries'
    }
  },
  {
    id: 'peanuts',
    name: 'Peanuts',
    slug: 'peanuts',
    description: 'Nigerian peanuts sourced for export and wholesale.',
    image: 'https://images.unsplash.com/photo-1757283961582-ab596b0ca595?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxmcmVzaCUyMHlhbXN8ZW58MHx8fHwxNzcxMjgwMTE4fDA&ixlib=rb-4.1.0&q=85',
    category: 'Nuts',
    details: {
      packaging: 'Bags or cartons',
      origin: 'Nigeria',
      notes: 'Wholesale enquiries welcome'
    }
  },
  {
    id: 'cashew',
    name: 'Cashew',
    slug: 'cashew',
    description: 'Nigerian cashew nuts for wholesale and export.',
    image: 'https://images.unsplash.com/photo-1757283961582-ab596b0ca595?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxmcmVzaCUyMHlhbXN8ZW58MHx8fHwxNzcxMjgwMTE4fDA&ixlib=rb-4.1.0&q=85',
    category: 'Nuts',
    details: {
      packaging: 'Various formats available',
      origin: 'Nigeria',
      notes: 'Contact for pricing and availability'
    }
  },
  {
    id: 'locust-beans',
    name: 'Locust Beans',
    slug: 'locust-beans',
    description: 'Nigerian locust beans (iru/dawadawa) for wholesale supply.',
    image: 'https://images.unsplash.com/photo-1757283961582-ab596b0ca595?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxmcmVzaCUyMHlhbXN8ZW58MHx8fHwxNzcxMjgwMTE4fDA&ixlib=rb-4.1.0&q=85',
    category: 'Condiments',
    details: {
      packaging: 'Appropriate packaging formats',
      origin: 'Nigeria',
      notes: 'Available for export enquiries'
    }
  },
  {
    id: 'dried-fish',
    name: 'Dried Fish',
    slug: 'dried-fish',
    description: 'Nigerian dried fish sourced for wholesale distribution.',
    image: 'https://images.unsplash.com/photo-1757283961582-ab596b0ca595?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxmcmVzaCUyMHlhbXN8ZW58MHx8fHwxNzcxMjgwMTE4fDA&ixlib=rb-4.1.0&q=85',
    category: 'Seafood',
    details: {
      packaging: 'Cartons or bulk packaging',
      origin: 'Nigeria',
      notes: 'Subject to sourcing availability'
    }
  },
  {
    id: 'crayfish',
    name: 'Crayfish',
    slug: 'crayfish',
    description: 'Nigerian dried crayfish for export and wholesale.',
    image: 'https://images.unsplash.com/photo-1757283961582-ab596b0ca595?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxmcmVzaCUyMHlhbXN8ZW58MHx8fHwxNzcxMjgwMTE4fDA&ixlib=rb-4.1.0&q=85',
    category: 'Seafood',
    details: {
      packaging: 'Bags or cartons',
      origin: 'Nigeria',
      notes: 'Contact for wholesale discussions'
    }
  },
  {
    id: 'prawn',
    name: 'Prawn (Dried)',
    slug: 'prawn',
    description: 'Nigerian dried prawn sourced for wholesale supply.',
    image: 'https://images.unsplash.com/photo-1757283961582-ab596b0ca595?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxmcmVzaCUyMHlhbXN8ZW58MHx8fHwxNzcxMjgwMTE4fDA&ixlib=rb-4.1.0&q=85',
    category: 'Seafood',
    details: {
      packaging: 'Various packaging options',
      origin: 'Nigeria',
      notes: 'Wholesale enquiries supported'
    }
  },
  {
    id: 'cocoyam',
    name: 'Cocoyam',
    slug: 'cocoyam',
    description: 'Nigerian cocoyam sourced for wholesale and export.',
    image: 'https://customer-assets.emergentagent.com/job_african-agro-export/artifacts/ix839s09_cocoyam.jpg',
    category: 'Root Vegetables',
    details: {
      packaging: 'Cartons or palletized shipments',
      origin: 'Nigeria',
      notes: 'Contact for availability'
    }
  },
  {
    id: 'poundo',
    name: 'Poundo',
    slug: 'poundo',
    description: 'Nigerian poundo yam flour for wholesale distribution.',
    image: 'https://images.unsplash.com/photo-1655912108021-5a81aa63cc3d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxjYXNzYXZhJTIwbGVhdmVzfGVufDB8fHx8MTc3MTI4MDEyMnww&ixlib=rb-4.1.0&q=85',
    category: 'Processed Foods',
    details: {
      packaging: 'Cartons and bulk options',
      origin: 'Nigeria',
      notes: 'Available for wholesale enquiries'
    }
  },
  {
    id: 'semovita',
    name: 'Semovita',
    slug: 'semovita',
    description: 'Nigerian semovita for wholesale supply.',
    image: 'https://images.unsplash.com/photo-1655912108021-5a81aa63cc3d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxjYXNzYXZhJTIwbGVhdmVzfGVufDB8fHx8MTc3MTI4MDEyMnww&ixlib=rb-4.1.0&q=85',
    category: 'Processed Foods',
    details: {
      packaging: 'Various packaging sizes',
      origin: 'Nigeria',
      notes: 'Wholesale and export supported'
    }
  },
  {
    id: 'jollof-mix',
    name: 'Jollof Mix',
    slug: 'jollof-mix',
    description: 'Nigerian jollof rice seasoning mix for wholesale.',
    image: 'https://images.unsplash.com/photo-1757283961582-ab596b0ca595?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxmcmVzaCUyMHlhbXN8ZW58MHx8fHwxNzcxMjgwMTE4fDA&ixlib=rb-4.1.0&q=85',
    category: 'Seasonings',
    details: {
      packaging: 'Cartons for retail or bulk',
      origin: 'Nigeria',
      notes: 'Contact for pricing discussions'
    }
  },
  {
    id: 'indomie',
    name: 'Indomie Noodles',
    slug: 'indomie',
    description: 'Indomie instant noodles popular across African markets.',
    image: 'https://images.unsplash.com/photo-1757283961582-ab596b0ca595?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxmcmVzaCUyMHlhbXN8ZW58MHx8fHwxNzcxMjgwMTE4fDA&ixlib=rb-4.1.0&q=85',
    category: 'Instant Foods',
    details: {
      packaging: 'Cartons for wholesale distribution',
      origin: 'Nigeria',
      notes: 'Available for export enquiries'
    }
  },
  {
    id: 'dried-ugba',
    name: 'Dried Ugba',
    slug: 'dried-ugba',
    description: 'Nigerian dried ugba (oil bean seeds) for wholesale.',
    image: 'https://customer-assets.emergentagent.com/job_african-agro-export/artifacts/egmfupyr_dried%20ugba.jpg',
    category: 'Processed Foods',
    details: {
      packaging: 'Appropriate packaging formats',
      origin: 'Nigeria',
      notes: 'Contact for sourcing enquiries'
    }
  },
  {
    id: 'snails',
    name: 'Dried Snails',
    slug: 'snails',
    description: 'Nigerian dried snails sourced for wholesale and export.',
    image: 'https://customer-assets.emergentagent.com/job_african-agro-export/artifacts/12qqdb0s_snails.jpg',
    category: 'Seafood',
    details: {
      packaging: 'Cartons or bulk packaging',
      origin: 'Nigeria',
      notes: 'Available for export enquiries'
    }
  }
];

export const howItWorksSteps = [
  {
    id: 1,
    title: 'Submit Enquiry',
    description: 'Contact us with details about the product, quantity, and destination requirements.',
    icon: 'MessageSquare'
  },
  {
    id: 2,
    title: 'Availability & Pricing',
    description: 'We discuss product availability, pricing, and delivery timelines based on your needs.',
    icon: 'FileText'
  },
  {
    id: 3,
    title: 'Documentation',
    description: 'Export documentation and shipment preparation are coordinated based on destination requirements.',
    icon: 'FileCheck'
  },
  {
    id: 4,
    title: 'Shipment Preparation',
    description: 'Products are prepared and packaged according to your specifications for dispatch.',
    icon: 'Ship'
  },
  {
    id: 5,
    title: 'Dispatch & Coordination',
    description: 'We coordinate the shipment and provide updates as your order moves to destination.',
    icon: 'PackageCheck'
  }
];

export const galleryImages = [
  {
    id: 1,
    url: 'https://images.unsplash.com/photo-1619023283528-3a8589b0069e',
    title: 'Large-Scale Farming Operations',
    category: 'farming'
  },
  {
    id: 2,
    url: 'https://images.unsplash.com/photo-1587293852726-70cdb56c2866?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHx3YXJlaG91c2V8ZW58MHx8fHwxNzcxMjgwMTY4fDA&ixlib=rb-4.1.0&q=85',
    title: 'Modern Warehouse Facility',
    category: 'warehouse'
  },
  {
    id: 3,
    url: 'https://images.unsplash.com/photo-1673732280286-bde8e813ad6b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxxdWFsaXR5JTIwaW5zcGVjdGlvbnxlbnwwfHx8fDE3NzEyODAxNjJ8MA&ixlib=rb-4.1.0&q=85',
    title: 'Quality Inspection Process',
    category: 'quality'
  },
  {
    id: 4,
    url: 'https://images.unsplash.com/photo-1678182451047-196f22a4143e',
    title: 'Container Shipping',
    category: 'shipping'
  },
  {
    id: 5,
    url: 'https://images.unsplash.com/photo-1606964212858-c215029db704?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHxsb2dpc3RpY3N8ZW58MHx8fHwxNzcxMjgwMTczfDA&ixlib=rb-4.1.0&q=85',
    title: 'Export Logistics',
    category: 'shipping'
  },
  {
    id: 6,
    url: 'https://images.unsplash.com/photo-1757283961544-e161ac41b201?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwyfHxmcmVzaCUyMHlhbXN8ZW58MHx8fHwxNzcxMjgwMTE4fDA&ixlib=rb-4.1.0&q=85',
    title: 'Premium Quality Produce',
    category: 'products'
  }
];


export const downloadResources = [
  {
    id: 1,
    title: 'Product Catalog 2025',
    description: 'Complete catalog of all our export products with specifications',
    fileSize: '2.4 MB',
    fileType: 'PDF',
    category: 'catalog'
  },
  {
    id: 2,
    title: 'Quality Certifications',
    description: 'Our international quality and safety certifications',
    fileSize: '1.8 MB',
    fileType: 'PDF',
    category: 'certification'
  },
  {
    id: 3,
    title: 'Export Process Guide',
    description: 'Step-by-step guide to ordering and receiving your products',
    fileSize: '950 KB',
    fileType: 'PDF',
    category: 'guide'
  }
];
